// **************************************************
// Scroll to top
// **************************************************

attachEvent('.go-to-top', 'click', (ev) => {
  ev.preventDefault();
  // eslint-disable-next-line
  if (typeof fullpage_api === 'object') {
    // eslint-disable-next-line
    fullpage_api.moveTo(1);
  } else {
    document.body.scrollIntoView({ behavior: 'smooth' }, true);
  }
});
